import {
  Fragment,
  JSXElementConstructor,
  PropsWithChildren,
  ReactElement,
} from 'react';

type AppProviderProps = PropsWithChildren & {
  components: Array<JSXElementConstructor<PropsWithChildren<unknown>>>;
};

export const AppProvider = (props: AppProviderProps): ReactElement => {
  return (
    <Fragment>
      {props.components.reduceRight((accumulator, Component) => {
        return <Component>{accumulator}</Component>;
      }, props.children)}
    </Fragment>
  );
};
